class PromotionalOffer {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.initCountdown();
    // this.checkCartForGifts();
  }

  bindEvents() {
    // Toggle promotional offer content
    document.addEventListener('click', (e) => {
      if (e.target.closest('.promotional-offer__toggle')) {
        this.toggleContent(e.target.closest('.promotional-offer'));
      }
    });

    // Listen for cart updates
    /*document.addEventListener('cart:refresh', () => {
      this.handleCartUpdate();
    });

    // Listen for cart changes
    document.addEventListener('cart:update', () => {
      this.handleCartUpdate();
    });*/

    // Listen for quantity changes
    /*document.addEventListener('change', (e) => {
      if (e.target.name === 'quantity' || e.target.closest('.quantity__input')) {
        this.handleQuantityChange();
      }
    });*/
  }

  toggleContent(offerElement) {
    const content = offerElement.querySelector('.promotional-offer__content');
    const toggle = offerElement.querySelector('.promotional-offer__toggle');
    
    if (content.classList.contains('expanded')) {
      content.classList.remove('expanded');
      toggle.classList.remove('rotated');
    } else {
      content.classList.add('expanded');
      toggle.classList.add('rotated');
    }
  }

  initCountdown() {
    const countdownElements = document.querySelectorAll('.promotional-offer__countdown');
    
    countdownElements.forEach(countdown => {
      const durationMinutes = parseInt(countdown.dataset.countdownDuration) || 60; // Default 60 minutes
      const durationSeconds = durationMinutes * 60; // Convert to seconds
      const startTime = this.getSessionStartTime();
      const endTime = startTime + (durationSeconds * 1000);
      
      this.updateCountdown(countdown, endTime);
      
      // Update countdown every second
      setInterval(() => {
        this.updateCountdown(countdown, endTime);
      }, 1000);
    });
  }

  getSessionStartTime() {
    let startTime = sessionStorage.getItem('promo_session_start');
    
    if (!startTime) {
      startTime = Date.now();
      sessionStorage.setItem('promo_session_start', startTime);
    }
    
    return parseInt(startTime);
  }

  updateCountdown(countdownElement, endTime) {
    const now = Date.now();
    const timeLeft = Math.max(0, endTime - now);
    
    if (timeLeft <= 0) {
      countdownElement.innerHTML = '<span>00H</span><span>00M</span><span>00S</span>';
      return;
    }
    
    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    
    countdownElement.innerHTML = `
      <span>${hours.toString().padStart(2, '0')}H</span>
      <span>${minutes.toString().padStart(2, '0')}M</span>
      <span>${seconds.toString().padStart(2, '0')}S</span>
    `;
  }

  async handleCartUpdate() {
    const cart = await this.getCart();
    this.checkAndManageGifts(cart);
  }

  async handleQuantityChange() {
    // Debounce the quantity change to avoid too many requests
    clearTimeout(this.quantityChangeTimeout);
    this.quantityChangeTimeout = setTimeout(async () => {
      const cart = await this.getCart();
      this.checkAndManageGifts(cart);
    }, 500);
  }

  async getCart() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  checkAndManageGifts(cart) {
    if (!cart) return;

    const promotionalOffers = document.querySelectorAll('.promotional-offer');
    
    promotionalOffers.forEach(offer => {
      const giftElements = offer.querySelectorAll('.promotional-offer__gift');
      const minimumQuantity = parseInt(offer.dataset.minimumQuantity) || 4;
      
      // Check if main product quantity meets minimum requirement
      const mainProductQuantity = this.getMainProductQuantity(cart);
      /*
      if (mainProductQuantity >= minimumQuantity) {
        // Add gifts if not already in cart
        giftElements.forEach(gift => {
          this.ensureGiftInCart(gift, cart);
        });
      } else {
        // Remove gifts if main product quantity is below minimum
        giftElements.forEach(gift => {
          this.removeGiftFromCart(gift, cart);
        });
      }*/
    });
  }

  getMainProductQuantity(cart) {
    // Get the current product page product ID
    const currentProductId = this.getCurrentProductId();
    if (!currentProductId) return 0;

    // Find the main product in cart
    const mainProductItem = cart.items.find(item => 
      item.product_id === currentProductId && !this.isGiftItem(item)
    );

    return mainProductItem ? mainProductItem.quantity : 0;
  }

  getCurrentProductId() {
    // Try to get product ID from various sources
    const productIdElement = document.querySelector('[data-product-id]');
    if (productIdElement) {
      return parseInt(productIdElement.dataset.productId);
    }

    // Try to get from URL
    const urlParams = new URLSearchParams(window.location.search);
    const productId = urlParams.get('id');
    if (productId) {
      return parseInt(productId);
    }

    return null;
  }

  isGiftItem(item) {
    // Check if item has gift properties or is marked as gift
    return item.properties && item.properties._gift === 'true';
  }

  async ensureGiftInCart(giftElement, cart) {
    const variantId = giftElement.dataset.giftVariantId;
    const productId = giftElement.dataset.giftProductId;
    
    if (!variantId) return;

    // Check if gift is already in cart
    const giftInCart = cart.items.find(item => 
      item.variant_id === parseInt(variantId) && this.isGiftItem(item)
    );

    if (!giftInCart) {
      await this.addGiftToCart(variantId, productId);
    }
  }

  async removeGiftFromCart(giftElement, cart) {
    const variantId = giftElement.dataset.giftVariantId;
    
    if (!variantId) return;

    // Find gift in cart
    const giftInCart = cart.items.find(item => 
      item.variant_id === parseInt(variantId) && this.isGiftItem(item)
    );

    if (giftInCart) {
      await this.removeItemFromCart(giftInCart.key);
    }
  }

  async addGiftToCart(variantId, productId) {
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('properties[_gift]', 'true');
      formData.append('properties[_gift_product_id]', productId);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        // Trigger cart refresh
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
        console.log('Gift added to cart:', variantId);
      } else {
        console.error('Error adding gift to cart:', await response.json());
      }
    } catch (error) {
      console.error('Error adding gift to cart:', error);
    }
  }

  async removeItemFromCart(itemKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      });

      if (response.ok) {
        // Trigger cart refresh
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
        console.log('Gift removed from cart:', itemKey);
      } else {
        console.error('Error removing gift from cart:', await response.json());
      }
    } catch (error) {
      console.error('Error removing gift from cart:', error);
    }
  }

  checkCartForGifts() {
    // Check if there are any gifts in cart that should be removed
    // (e.g., if user navigated away and came back)
    this.handleCartUpdate();
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new PromotionalOffer();
});

// Initialize on section load (for theme editor)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.promotional-offer')) {
    new PromotionalOffer();
  }
});
